const VALIDATE_EMAIL_RESPONSE = {
  User: 'User',
  TokenError: 'TokenError',
};

export default VALIDATE_EMAIL_RESPONSE;
